export type MeasurementPage =
  | 'overview'
  | 'prompts'
  | 'sources-domains'
  | 'sources-urls'
  | 'sources-gap'
  | 'brands'
  | 'clusters'
  | 'engines'
  | 'actions'
  | 'chats'
  | 'profile';

export interface NavItem {
  id: MeasurementPage;
  label: string;
  group: 'Overview' | 'Sources' | 'Brand' | 'Actions' | 'Engines' | 'Project';
}

export const NAV: NavItem[] = [
  { id: 'overview', label: 'Overview', group: 'Overview' },
  { id: 'prompts', label: 'Prompts', group: 'Overview' },
  { id: 'sources-domains', label: 'Domains', group: 'Sources' },
  { id: 'sources-urls', label: 'URLs', group: 'Sources' },
  { id: 'sources-gap', label: 'Gap analysis', group: 'Sources' },
  { id: 'brands', label: 'Brands', group: 'Brand' },
  { id: 'clusters', label: 'Topic clusters', group: 'Brand' },
  { id: 'actions', label: 'Recommendations', group: 'Actions' },
  { id: 'chats', label: 'Chats', group: 'Actions' },
  { id: 'engines', label: 'Engines & cost', group: 'Engines' },
  { id: 'profile', label: 'Profile', group: 'Project' },
];
